import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SegmentsTransitionsChart from '../../SegmentsTransitionsChart';
import MonthsDropdown from '../../MonthsDropdown';
import TransitionsTable from '../../TransitionsTable';
import Button from '../../../../../components/Buttons/Button';
import CollapsibleSlot from '../../../../../components/CollapsibleSlot';
import ErrorStateWithReload from '../../../../../components/ErrorStateWithReload';
import { segmentTransitionsSelector } from '../../../selectors';
import { fetchSegmentTransitions } from '../../../actions';
import LegendApp from '../LegendApp';

const emptyObject = {};

const SegmentTransitions = () => {
  const dispatch = useDispatch();

  const { settings, data, filters } = useSelector(segmentTransitionsSelector);

  const [isOpen, setOpen] = useState(false);

  const handlePeriodChange = (value) => {
    dispatch(fetchSegmentTransitions({ month_date: value }));
  };

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="segment-transitions">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <h4 className="section-body-header__title">Segment Transitions</h4>
        </div>
        <div className="section-body-header__right">
          <MonthsDropdown
            selected={filters.month_date}
            disabled={settings.pending}
            onChange={handlePeriodChange}
          />
          <div className="section-separator--v" />
          <Button
            shape="square"
            variant="secondary"
            active={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <span className="hicon-list-button" />
          </Button>
        </div>
      </header>
      <SegmentsTransitionsChart
        settings={settings}
        data={data}
        withEndSeries
        selectedDate={filters.month_date}
        footerRight={<LegendApp />}
      />
      <CollapsibleSlot show={isOpen} className="toggle-collapsible--slide-in-out">
        <TransitionsTable data={data.table_data || emptyObject} isPending={settings.pending} />
      </CollapsibleSlot>
    </div>
  );
};

export default SegmentTransitions;
